import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getOrgUserList (params) {
  return fetch.post(URL.getOrgUserList, params);
}

export function addOrgUser (params) {
  return fetch.post(URL.addOrgUser, params);
}

export function getFatherOrgList (params) {
  return fetch.post(URL.getFatherOrgList, params);
}

export function freezeOrgAccount (params) {
  return fetch.post(URL.freezeOrgAccount, params);
}

export function invalidOrgAccount (params) {
  return fetch.post(URL.invalidOrgAccount, params);
}

export function getTradeInfoList (params) {
  return fetch.post(URL.getTradeInfoList, params);
}

export function getOrgUserDetail (params) {
  return fetch.post(URL.getOrgUserDetail, params);
}

export function resetPassword (params) {
  return fetch.post(URL.resetPassword, params);
}

export function updateOrgUserDetail (params) {
  return fetch.post(URL.updateOrgUserDetail, params);
}

export function importApplyInfo (params) {
  return fetch.post(URL.importApplyInfo, params);
}

export function exportOrgInfo (params) {
  return fetch.post(URL.exportOrgInfo, params);
}

export function synchroOrgInfo (params) {
  return fetch.post(URL.synchroOrgInfo, params);
}

export function selectOrgApplyList (params) {
  return fetch.post(URL.selectOrgApplyList, params);
}
export function queryOrganization (params) {
  return fetch.post(URL.queryOrganization, params);
}



// WEBPACK FOOTER //
// ./src/api/modules/accountAdmin.js